import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPostSlice {
  currentBlogSLug: Record<string, string>;
}

const initialState: IPostSlice = {
  currentBlogSLug: {},
};

export const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    setCurrentBlogSlug: (
      state,
      action: PayloadAction<Record<string, string>>
    ) => {
      state.currentBlogSLug = action.payload;
    },
  },
});

export const { setCurrentBlogSlug } = postSlice.actions;
export default postSlice.reducer;
